var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42236 39.2181L20.7897 45.332L35.5782 39.2181C35.5782 37.999 35.4797 36.7402 34.792 35.7336C34.1802 34.8382 33.2037 33.8918 31.764 33.3961C29.3035 32.5491 25.7472 30.4045 24.2766 29.4382V25.5306C24.8649 24.808 26.0565 22.9592 26.117 21.3458C26.8733 20.766 28.1287 19.2181 27.1002 17.6652C26.7534 17.1417 26.8976 16.0324 27.0719 14.6915C27.4313 11.9271 27.9671 7.24636 24.2766 7.24636C22.9338 6.02296 21.9661 5.73047 20.0003 5.73047C11.7638 5.73047 12.4567 11.0605 12.9287 14.6915C13.103 16.0324 13.2472 17.1417 12.9004 17.6652C11.8719 19.2181 13.1273 20.766 13.8836 21.3458C13.9441 22.9592 15.1357 24.808 15.7239 25.5306V29.4382C14.2534 30.4045 10.6971 32.5491 8.23661 33.3961C6.79686 33.8918 5.82035 34.8382 5.20859 35.7336C4.52089 36.7402 4.42236 37.999 4.42236 39.2181Z",
    fill: "#1A9B60"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#1A9B60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconActive);
export default __webpack_public_path__ + "static/media/user_icon_active.a11d350b3318eb2dec6d585f848e7c5c.svg";
export { ForwardRef as ReactComponent };